export const EXCEL_EXTENSION = 'xlsx';
export const ZIP_EXTENSION = 'zip';
// export const MIME_TYPE_EXCEL = 'application/vnd.ms-excel';
export const MIME_TYPE_EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const MIME_TYPE_OCTET_STREAM = 'application/octet-stream';
